"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var getSvg = function getSvg(fillColor) {
  return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"".concat(fillColor, "\"><path fill=\"none\" d=\"M0 0h24v24H0z\"/><path d=\"M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z\"/></svg>");
};

var StyledButton = /*#__PURE__*/_styledComponents["default"].button.withConfig({
  displayName: "indexstyles__StyledButton",
  componentId: "sc-2nhc49-0"
})(["flex:0 0 2rem;border:0 none;cursor:pointer;display:block;text-transform:uppercase;text-decoration:none;text-align:center;background:url(data:image/svg+xml;base64,", ") no-repeat;width:2rem;height:2rem;margin-top:0.25rem;&&:focus{outline:2px solid ", ";}"], function (p) {
  return btoa(getSvg(p.theme.colorTextLabel));
}, function (p) {
  return p.theme.tokens.colorFocus;
});

exports.StyledButton = StyledButton;